//TODO: use a key flag in provider data from backend
export default ['shopify', 'woocommerce', 'clover', 'toast'];
